export function chooseDetectedTerm(terms, currentTerm, preferredTerm, fallbackTerm) {
    const available = new Set((terms || []).map(term => term.num));
    if (preferredTerm && available.has(preferredTerm)) return preferredTerm;
    if (currentTerm?.num && available.has(currentTerm.num)) return currentTerm.num;
    return terms?.[0]?.num || preferredTerm || fallbackTerm || null;
}
